<template>
  <section class="event-modal-passes-add-form">
    <div class="event-modal-passes-add-form__wrapper">
      <div class="event-modal-passes-add-form__header">
        <h1 class="event-modal-passes-add-form__header-title">
          <slot name="form-title"></slot>
        </h1>

        <button
          type="button"
          class="event-modal-passes-add-form__header-toggle"
          @click="$emit('hide')"
          v-if="showHide"
        >
          <icon name="hide" width="16" height="16" />
        </button>
      </div>

      <h2 class="event-modal-passes-add-form__title" v-if="packageUpload">
        <template v-if="packageUploadParticipant">
          {{ $t("event.passes.packageTitle__Participant") }}
        </template>

        <template v-else-if="packageUploadMontage">
          {{ $t("event.passes.packageTitle__Montage") }}
        </template>

        <template v-else>
          {{ $t("event.passes.packageTitle") }}
        </template>
      </h2>

      <div class="event-modal-passes-add-form__package" v-if="packageUpload">
        <p class="event-modal-passes-add-form__package-text">
          <template v-if="packageUploadParticipant">
            {{ $t("event.passes.packageDescription__Participant") }}
          </template>

          <template v-else-if="packageUploadMontage">
            {{ $t("event.passes.packageDescription__Montage") }}
          </template>

          <template v-else>
            {{ $t("event.passes.packageDescription") }}
          </template>
        </p>

        <a
          :href="packageUploadTemplateSrc"
          download
          class="event-modal-passes-add-form__package-link"
        >
          <icon name="blank-doc" />
          <span>
            {{ $t("event.passes.packageDownloadBlank") }}

            <small>{{ packageUploadTemplateSize }}</small>
          </span>
        </a>

        <div class="event-modal-passes-add-form__package-upload">
          <input
            type="file"
            class="event-modal-passes-add-form__package-upload-file"
            @change="uploadPackage"
          />

          <PrimaryButton
            class="event-modal-passes-add-form__package-upload-btn"
          >
            {{ $t("event.passes.packageUploadFile") }}
          </PrimaryButton>
        </div>
      </div>

      <slot />

      <div
        class="event-modal-passes-add-form__row event-modal-passes-add-form__row_submit"
      >
        <PrimaryButton
          @click="$emit('submit')"
          v-if="!isSubmitting"
          :disabled="submitDisabled"
        >
          {{ $t("common.saveBtn") }}
        </PrimaryButton>

        <PrimaryButton :disabled="true" v-else>
          {{ $t("common.savingBtn") }}
        </PrimaryButton>

        <span v-if="hasErrors" class="text-error">
          {{ $t("common.validationError") }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { PrimaryButton } from "@v2/shared/ui/components";

export default {
  name: "EventModalAddForm",

  props: {
    showHide: {
      type: Boolean,
      default: false
    },

    packageUpload: {
      type: Boolean,
      default: true
    },

    packageUploadParticipant: {
      type: Boolean,
      default: false
    },

    packageUploadMontage: {
      type: Boolean,
      default: false
    },

    packageUploadTemplateSrc: {
      type: String,
      default: ""
    },

    packageUploadTemplateSize: {
      type: String,
      default: ""
    },

    isSubmitting: {
      type: Boolean,
      default: false
    },

    hasErrors: {
      type: Boolean,
      default: false
    },
    submitDisabled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    PrimaryButton
  },

  methods: {
    uploadPackage(e) {
      if (!e.target.files[0]) {
        return;
      }

      this.$emit("package-upload-handler", e.target.files[0]);
      e.target.value = "";
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";
.event-modal-passes-add-form {
  border-top: 2px solid #f1f1f1;

  &__wrapper {
    width: 780px;
    padding-left: 80px;

    @include respond-down(lg) {
      padding: 38px 24px 0 24px;
      box-sizing: border-box;
      width: 100%;
      max-width: 768px;
    }

    @include respond-down(md) {
      width: 100%;
      padding: 0 16px;

      box-sizing: border-box;
    }
  }

  &__header {
    padding-top: 42px;
    padding-bottom: 30px;

    display: flex;
    justify-content: space-between;

    @include respond-down(lg) {
      padding: 0 0 40px 0;
    }

    @include respond-down(md) {
      padding: 30px 0 16px 0;
    }

    &-title {
      font-size: 21px;
      font-weight: 500;
      line-height: 1.14;
      color: #262626;

      @include respond-down(md) {
        font-size: 16px;
      }
    }

    &-toggle {
      @include button-clean();
    }
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    color: #505050;
    margin: 0 0 16px 0;

    @include respond-down(lg) {
      display: none;
    }
  }

  &__package {
    display: flex;
    margin-bottom: 32px;

    @include respond-down(lg) {
      display: none;
    }

    &-text {
      width: 310.5px;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.54;
      letter-spacing: normal;
      color: #6d7179;
      margin: 0;
    }

    &-link {
      margin-left: 88px;
      margin-right: auto;

      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;

      color: #6d7179;

      text-decoration: none;

      display: flex;

      .svg-icon {
        width: 16px;
        height: 16px;

        margin-right: 9px;
      }

      small {
        display: block;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: #a3a8b3;
        margin-top: 2px;
        margin-left: 1px;
      }
    }

    &-upload {
      align-self: flex-start;

      position: relative;

      &-file {
        position: absolute;
        width: 100%;
        height: 100%;

        opacity: 0;

        cursor: pointer;
      }

      &-file:hover + &-btn,
      &-file:focus + &-btn {
        background: #0070d2;
      }

      &-btn {
        padding-left: 32.5px;
        padding-right: 32.5px;
      }
    }
  }

  &__row {
    padding-bottom: 32px;

    &.flex {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      @include respond-down(md) {
        flex-wrap: wrap;
        padding: 0;
      }
    }

    &-col {
      flex-shrink: 0;
      &.w-full {
        flex: 1;
      }
      $cols: 160 180 200 270 380 450 560 600;

      @each $col in $cols {
        &._#{$col} {
          width: #{$col}px;

          @include respond-down(lg) {
            margin-right: 20px;
            width: 535px;

            &._200 {
              width: 184px;
            }

            &._270 {
              width: 248px;
            }

            &._380 {
              width: 350px;
            }
            &._450 {
              width: 400px;
            }
            &._560 {
              width: 516px;
            }
          }

          @include respond-down(md) {
            width: 100%;
            margin-bottom: 16px;

            &._380,
            &._270 {
              width: 100%;
            }
            &._560 {
              max-width: 100%;
              width: 100%;
            }
            &._450 {
              max-width: 100%;
              width: 100%;
            }
            &._200 {
              width: 100%;
            }
            &._160 {
              & .input-label {
                width: 80%;
                & .event-modal-auto-passes__add-cargo-delete {
                  margin: 0 0 10px 25px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.link-text {
  display: block;
  margin-bottom: 5px;
}
.manager-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: #000;
  margin-bottom: 10px;
}
</style>
